<form class="modal-container-content" [formGroup]="this.form">
  <app-input type="password" formControlName="current_password">Huidig wachtwoord</app-input>
  @if (this.isSubmitted) {
    <app-error-display [control]="this.form.get('current_password')"></app-error-display>
  }

  <app-input type="password" formControlName="password">Nieuw wachtwoord</app-input>
  @if (this.isSubmitted) {
    <app-error-display [control]="this.form.get('password')"></app-error-display>
  }

  <app-input type="password" formControlName="confirm_password">Nieuw wachtwoord herhalen</app-input>
  @if (this.isSubmitted) {
    <app-error-display [control]="this.form.get('confirm_password')"></app-error-display>
  }

  <app-password-validation-display [form]="this.form"></app-password-validation-display>
</form>

<div class="modal-container-footer">
  <app-button (click)="this.submit()" onkeyup="this.submit()">Wijzigen</app-button>
  <app-button type="outline" (click)="this.modalRef.close()" onKeyUp="">Annuleren</app-button>
</div>
